import numeral from 'numeral';
import querySearch from 'stringquery';

const formatNumber = (number) => {
    let result = number;
    if (number) {
        result = numeral(number).format('0,0');
    }
    return result;
}

const parseQueryParams = (props) => {
    if (props && props.location) {
        const parsed = querySearch(props.location.search);
        return parsed;
    } else {
        return null;
    }
}

export default {
    formatNumber,
    parseQueryParams,
}


// WEBPACK FOOTER //
// ./src/resources/utils/index.js